import React from 'react';
import styled from '@emotion/styled';

export default function FooterSocialLinks() {
  return (
    <SocialLinksWrap>
      <a
        href='https://www.linkedin.com/company/400779'
        target='_blank'
        rel='noopener noreferrer'
        className='linkButton'
      >
        <LinkedInLogo />
      </a>
      <a
        href='https://www.facebook.com/MadisonSPECS'
        target='_blank'
        rel='noopener noreferrer'
        className='linkButton'
      >
        <FacebookLogo />
      </a>
      <a
        href='https://x.com/MadisonSPECS'
        target='_blank'
        rel='noopener noreferrer'
        className='linkButton'
      >
        <XLinkLogo />
      </a>
    </SocialLinksWrap>
  );
}

const SocialLinksWrap = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 30px 0px 48px;
  .linkButton {
    align-items: center;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 4.5px;
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: center;
    transition: all 0.2s ease;
    width: 36px;
    &:hover {
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  @media (min-width: 768px) {
    gap: 18px;
    justify-content: flex-start;
    margin: 40px auto 0;
    .linkButton {
      width: 40px;
      height: 40px;
      border-radius: 5px;
    }
  }
  @media (min-width: 1024px) {
    margin-top: 60px;
    max-width: 1024px;
  }
  @media (min-width: 1260px) {
    margin-top: 60px;
    max-width: 1450px;
    padding: 0 40px;
  }
`;

export function XLinkLogo() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.0268 0.961517L8.35514 10.932L0.980713 19.0384H2.64044L9.0969 11.9411L14.3134 19.0384H19.9615L12.2208 8.50713L19.0852 0.961517H17.4255L11.4794 7.498L6.67493 0.961517H1.0268ZM3.46775 2.20551H6.06251L17.5205 17.7943H14.9258L3.46775 2.20551Z'
        fill='#011152'
      />
    </svg>
  );
}
export function FacebookLogo() {
  return (
    <svg width='9' height='18' viewBox='0 0 9 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.27317 17.6427H2.67726V17.3829C2.67726 14.6767 2.67528 11.97 2.68162 9.26379C2.68201 9.06534 2.63607 9.00235 2.43088 9.01107C2.02249 9.0285 1.61251 9.01622 1.20333 9.01622C1.13282 9.01622 1.06192 9.01622 0.980713 9.01622V5.9717H2.67726C2.67726 5.87505 2.67686 5.799 2.67726 5.72334C2.68162 5.05668 2.66617 4.38923 2.69469 3.72376C2.73272 2.83568 3.00445 2.02642 3.62714 1.36571C4.16308 0.797685 4.84281 0.476042 5.60413 0.429301C6.70849 0.361565 7.818 0.37741 8.94138 0.357208V3.3435C8.87958 3.3435 8.81066 3.3435 8.74134 3.3435C8.19352 3.3435 7.64569 3.34191 7.09787 3.34389C6.55678 3.34587 6.27396 3.618 6.26802 4.15553C6.26089 4.74851 6.26643 5.34188 6.26643 5.96021H9.00238C8.89701 6.98931 8.79442 7.99029 8.68945 9.01265H6.27317V17.6423V17.6427Z'
        fill='#011152'
      />
    </svg>
  );
}
export function LinkedInLogo() {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_2001_35)'>
        <path
          d='M4.06216 5.91135H0.592084C0.438026 5.91135 0.313354 6.03651 0.313354 6.19069V17.3631C0.313354 17.5175 0.438243 17.6425 0.592084 17.6425H4.06216C4.21621 17.6425 4.34089 17.5173 4.34089 17.3631V6.19069C4.34089 6.03629 4.216 5.91135 4.06216 5.91135Z'
          fill='#011152'
        />
        <path
          d='M2.32835 0.357208C1.06565 0.357208 0.0384521 1.38558 0.0384521 2.64956C0.0384521 3.91354 1.06565 4.94278 2.32835 4.94278C3.59106 4.94278 4.61631 3.91397 4.61631 2.64956C4.61631 1.38558 3.58998 0.357208 2.32835 0.357208Z'
          fill='#011152'
        />
        <path
          d='M12.8884 5.63348C11.4948 5.63348 10.4643 6.23396 9.83946 6.9163V6.19066C9.83946 6.03626 9.71458 5.91131 9.56074 5.91131H6.23759C6.08353 5.91131 5.95886 6.03648 5.95886 6.19066V17.3631C5.95886 17.5175 6.08375 17.6425 6.23759 17.6425H9.7001C9.85416 17.6425 9.97883 17.5173 9.97883 17.3631V11.8353C9.97883 9.97262 10.4838 9.24698 11.7793 9.24698C13.1905 9.24698 13.3026 10.4103 13.3026 11.9313V17.3633C13.3026 17.5177 13.4275 17.6427 13.5814 17.6427H17.0452C17.1992 17.6427 17.3239 17.5175 17.3239 17.3633V11.2351C17.3239 8.46525 16.7969 5.6337 12.8884 5.6337V5.63348Z'
          fill='#011152'
        />
      </g>
      <defs>
        <clipPath id='clip0_2001_35'>
          <rect
            width='17.2855'
            height='17.2855'
            fill='white'
            transform='translate(0.0384521 0.357208)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
